// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .app-updates {
  padding: 10% 5%;
  text-align: center;
}
.popup .app-updates p {
  font: 1.4em/1.2em vigaregular;
  text-align: center;
  color: #5c5c5c;
}
.popup .app-updates .rec-carousel-wrapper {
  margin: 5% 0 5% 0;
}
.popup .app-updates .rec-carousel-wrapper .rec-pagination {
  position: absolute;
  bottom: 35%;
}
.popup .app-updates .rec-carousel-wrapper .update-item {
  position: relative;
  margin-bottom: 40%;
}
.popup .app-updates .rec-carousel-wrapper figure {
  max-width: 250px;
  margin: auto;
}
.popup .app-updates .rec-carousel-wrapper figure img {
  width: 100%;
}
.popup .app-updates .rec-carousel-wrapper .item-txt {
  position: relative;
  bottom: -50px;
}
.popup .app-updates .rec-carousel-wrapper p.item-tit {
  font-size: 2em;
}
.popup .app-updates .rec-carousel-wrapper p.item-desc {
  font-size: 1.4em;
  margin-top: 2%;
  padding: 0 25px;
}
.popup .app-updates .buttons-bottom {
  margin-top: -20%;
}
.popup .app-updates .btn-brown {
  background-color: #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
  font: 1.7em/1 vigaregular;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/AppUpdatesContent.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,kBAAA;AAAR;AAEQ;EACI,6BAAA;EACA,kBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,iBAAA;AADZ;AAGY;EACI,kBAAA;EACA,WAAA;AADhB;AAIY;EACI,kBAAA;EACA,kBAAA;AAFhB;AAKY;EACI,gBAAA;EACA,YAAA;AAHhB;AAIgB;EACI,WAAA;AAFpB;AAKY;EACI,kBAAA;EACA,aAAA;AAHhB;AAMgB;EACI,cAAA;AAJpB;AAMgB;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAJpB;AASQ;EACI,gBAAA;AAPZ;AAUQ;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AARZ","sourcesContent":[".popup {\n    .app-updates {\n        padding: 10% 5%;\n        text-align: center;\n\n        p{\n            font: 1.4em/1.2em vigaregular;\n            text-align: center;\n            color: #5c5c5c;\n        }\n\n        .rec-carousel-wrapper{\n            margin: 5% 0 5% 0;\n\n            .rec-pagination{\n                position: absolute;\n                bottom: 35%;\n            }\n\n            .update-item{\n                position: relative;\n                margin-bottom: 40%;;\n            }\n\n            figure{\n                max-width: 250px;\n                margin: auto;\n                img{\n                    width: 100%;\n                }\n            }\n            .item-txt{\n                position: relative;\n                bottom: -50px;\n            }\n            p{\n                &.item-tit{\n                    font-size: 2em;\n                }\n                &.item-desc{\n                    font-size: 1.4em;\n                    margin-top: 2%;\n                    padding: 0 25px;\n                }\n            }\n        }\n\n        .buttons-bottom{\n            margin-top: -20%;\n        }\n        \n        .btn-brown{\n            background-color: #caa36c;\n            text-decoration: none;\n            text-align: center;\n            border-radius: 5px;\n            padding: 7% 0 7%;\n            display: block;\n            font: 1.7em/1 vigaregular;\n            color: white;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
